export default {"src":"/_next/static/media/recommended_tag.9e6f0f96.svg","height":25,"width":87,"blurWidth":0,"blurHeight":0};